<template>
  <div>
    <vxe-toolbar
      id="invoiceId"
      :custom="{storage: true}"
    >
      <template v-slot:buttons>
        <div
          v-if="tableData.length != 0"
          style="display: inline-block; color: firebrick;"
        >
          以下运单省平台SDK位置未上报，是否继续上报运单？
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      auto-resize
    >
      <vxe-table-column
        field="orderCode"
        title="运输单号"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="shippingNoteNumber"
        title="托运单号"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="driverName"
        title="实际承运人名称"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="vehicleLicense"
        title="车牌号"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="driverPhone"
        title="联系方式"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="coalTypeName"
        title="货物名称"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="startLocation"
        title="开启定位"
        min-width="100"
      />
      <vxe-table-column
        field="sendLocation"
        title="发送定位"
        min-width="100"
      />
      <vxe-table-column
        field="stopLocation"
        title="结束定位"
        min-width="100"
      />
    </vxe-table>
    <div style="margin-top: 30px;">
      <el-button @click="funcCancel">
        取消上报
      </el-button>
      <el-button type="primary" @click="funcSumbit">
        继续上报
      </el-button>
    </div>

  </div>
</template>
<script>
  import { reportTransportWaybill, verifyAPPLocationStatus } from '@/api/transport'
  export default {
    name: 'InvoiceList',
    data() {
      return {
        message: '',
        loading: false,
        tableData: [],
        codes: '',
      }
    },

    methods: {
      verifyAPPLocation(codes){
        this.tableData = []
        const rLoading = this.openLoading()
        this.codes = codes
        verifyAPPLocationStatus({ codes })
          .then((response) => {
            rLoading.close()
            this.tableData = response.data
          })
      },
      funcSumbit(){
        const codes = this.codes
        this.$confirm('确认上报监管平台吗？').then((_) => {
          const rLoading = this.openLoading()
          reportTransportWaybill({ codes })
            .then((response) => {
              rLoading.close()
              this.$message({ message: response.msg, type: 'success' })
              this.$emit('onHideReport')
            })
            .finally(() => {
              rLoading.close()
              this.$emit('onHideReport')
            })
        })
      },
	  funcCancel(){
		   this.$emit('onHideReport')
	  },
      //翻译
      formatterLoad({ cellValue }){
        if(cellValue == 1){
          return "已上报"
        }else{
          return "未上报"
        }
      },
      formatterUnload({ cellValue }){
        if(cellValue == 1){
          return "已上报"
        }else{
          return "未上报"
        }
      },
    }
  }
</script>
